"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// Modules
const react_1 = require("react");
// Components
const Image_1 = require("../Image");
// Styled
const Styled = __importStar(require("./Styled"));
// Icons
const Wallpaper_1 = __importDefault(require("@material-ui/icons/Wallpaper"));
function ProductImage(props) {
    const testId = `${props.testId}-ProductImage`;
    const [imageError, setImageError] = (0, react_1.useState)(false);
    const handleImageError = (0, react_1.useCallback)(() => {
        setImageError(true);
    }, []);
    return !props.image || props.image.includes('default-image') || imageError ? ((0, jsx_runtime_1.jsx)(Styled.IconWrapper, Object.assign({ "data-testid": `${testId}-icon`, className: `${testId}-icon`, smallDefaultIcon: props.smallDefaultIcon }, { children: (0, jsx_runtime_1.jsx)(Wallpaper_1.default, {}) }))) : ((0, jsx_runtime_1.jsx)(Styled.ImageWrapper, { children: (0, jsx_runtime_1.jsx)(Image_1.Image, { src: props.image, testId: testId, alt: props.alt, handleImageLoaded: props.handleImageLoaded, handleImageError: handleImageError }) }));
}
exports.ProductImage = ProductImage;
